module.exports = __webpack_public_path__ + "img/wx.19ef6487.png";